import { CuratedBox } from '../Components/CuratedBoxCarouseItem/CuratedBoxCarouselItem'

export type CuratedBoxesRecipesType = {
  relationships: {
    recipes: { data: { core_recipe_id: string }[] }
    collection: { data: Record<string, string>[] }
  }
  type: string
  id: string
  attributes: { title: string; tags: string[] }
}[]

export type AllRecipesType = {
  [key: string]: {
    coreRecipeId: string
    media: { images: { urls: { src: string }[] }[] }
  }
}

export const getCuratedBoxesRecipes = (
  allRecipes: AllRecipesType,
  curatedBoxesRecipes: CuratedBoxesRecipesType,
  isRecipeOutOfStock: (id: string) => boolean,
): CuratedBox[] => {
  return curatedBoxesRecipes?.map((curatedBox) => {
    const topInStockRecipes = curatedBox.relationships.recipes?.data.map(
      ({ core_recipe_id: id }: { core_recipe_id: string }) => {
        if (isRecipeOutOfStock(id)) return

        return {
          recipeId: allRecipes[id]?.coreRecipeId,
          recipeImageSrc: allRecipes[id]?.media?.images[0]?.urls[1]?.src,
        }
      },
    )
    return {
      type: curatedBox.type,
      id: curatedBox.id,
      curatedBoxCollectionId: curatedBox.relationships.collection.data[0].id,
      title: curatedBox.attributes.title,
      tags: curatedBox.attributes.tags,
      topInStockRecipes: topInStockRecipes.filter((recipes) => recipes !== undefined).slice(0, 4),
    }
  })
}
